import Style from "./SearchInfo.module.scss";

function SearchInfo({ searchItems }) {
  return (
    <div className={`${Style.info_wrap} pro-list`}>
      <span className={Style.info_btn}>
        <span className="material-symbols-outlined pro-fw-medium"> info </span>
      </span>
      <div className={Style.info_items_wrap}>
        <h6 className="pro-ttl h6 pro-mb-1">Search by</h6>
        <ul className={Style.info_list}>
          {searchItems?.map((item, index) => {
            return <li key={index}>{item}</li>;
          })}
        </ul>
      </div>
    </div>
  );
}

export default SearchInfo;
